import { render, staticRenderFns } from "./PlacementResult.vue?vue&type=template&id=656172ef&scoped=true"
import script from "./PlacementResult.vue?vue&type=script&lang=js"
export * from "./PlacementResult.vue?vue&type=script&lang=js"
import style0 from "./PlacementResult.vue?vue&type=style&index=0&id=656172ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656172ef",
  null
  
)

export default component.exports